var F = Object.defineProperty;
var L = (r, n, e) => n in r ? F(r, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[n] = e;
var g = (r, n, e) => L(r, typeof n != "symbol" ? n + "" : n, e);
function B() {
  return {
    kind: "transformation",
    type: "await",
    reference: B,
    async: !0,
    async _run(r) {
      return r.value = await r.value, r;
    }
  };
}
var U = /^(?:[\da-z+/]{4})*(?:[\da-z+/]{2}==|[\da-z+/]{3}=)?$/iu, W = /^[A-Z]{6}(?!00)[\dA-Z]{2}(?:[\dA-Z]{3})?$/u, J = /^[a-z][\da-z]*$/u, K = /^[+-]?\d+(?:\.\d+)?$/u, H = /^\d+$/u, Z = /^[\w+-]+(?:\.[\w+-]+)*@[\da-z]+(?:[.-][\da-z]+)*\.[a-z]{2,}$/iu, Q = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex, regexp/no-dupe-disjunctions -- false positives
  new RegExp("^(?:[\\u{1F1E6}-\\u{1F1FF}]{2}|\\u{1F3F4}[\\u{E0061}-\\u{E007A}]{2}[\\u{E0030}-\\u{E0039}\\u{E0061}-\\u{E007A}]{1,3}\\u{E007F}|(?:\\p{Emoji}\\uFE0F\\u20E3?|\\p{Emoji_Modifier_Base}\\p{Emoji_Modifier}?|\\p{Emoji_Presentation})(?:\\u200D(?:\\p{Emoji}\\uFE0F\\u20E3?|\\p{Emoji_Modifier_Base}\\p{Emoji_Modifier}?|\\p{Emoji_Presentation}))*)+$", "u")
), Y = /^(?:0[hx])?[\da-f]+$/iu, ee = /^#(?:[\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/iu, ne = /^\d{15}$|^\d{2}-\d{6}-\d{6}-\d$/u, re = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive
  /^(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])(?:\.(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])){3}$/u
), ie = /^(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:|(?:[\da-f]{1,4}:){1,6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,5}(?::[\da-f]{1,4}){1,2}|(?:[\da-f]{1,4}:){1,4}(?::[\da-f]{1,4}){1,3}|(?:[\da-f]{1,4}:){1,3}(?::[\da-f]{1,4}){1,4}|(?:[\da-f]{1,4}:){1,2}(?::[\da-f]{1,4}){1,5}|[\da-f]{1,4}:(?::[\da-f]{1,4}){1,6}|:(?:(?::[\da-f]{1,4}){1,7}|:)|fe80:(?::[\da-f]{0,4}){0,4}%[\da-z]+|::(?:f{4}(?::0{1,4})?:)?(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d)|(?:[\da-f]{1,4}:){1,4}:(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d))$/iu, ue = /^(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])(?:\.(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])){3}$|^(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:|(?:[\da-f]{1,4}:){1,6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,5}(?::[\da-f]{1,4}){1,2}|(?:[\da-f]{1,4}:){1,4}(?::[\da-f]{1,4}){1,3}|(?:[\da-f]{1,4}:){1,3}(?::[\da-f]{1,4}){1,4}|(?:[\da-f]{1,4}:){1,2}(?::[\da-f]{1,4}){1,5}|[\da-f]{1,4}:(?::[\da-f]{1,4}){1,6}|:(?:(?::[\da-f]{1,4}){1,7}|:)|fe80:(?::[\da-f]{0,4}){0,4}%[\da-z]+|::(?:f{4}(?::0{1,4})?:)?(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d)|(?:[\da-f]{1,4}:){1,4}:(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d))$/iu, se = /^\d{4}-(?:0[1-9]|1[0-2])-(?:[12]\d|0[1-9]|3[01])$/u, te = /^\d{4}-(?:0[1-9]|1[0-2])-(?:[12]\d|0[1-9]|3[01])T(?:0\d|1\d|2[0-3]):[0-5]\d$/u, le = /^(?:0\d|1\d|2[0-3]):[0-5]\d$/u, fe = /^(?:0\d|1\d|2[0-3])(?::[0-5]\d){2}$/u, ce = /^\d{4}-(?:0[1-9]|1[0-2])-(?:[12]\d|0[1-9]|3[01])T(?:0\d|1\d|2[0-3])(?::[0-5]\d){2}(?:\.\d{1,9})?(?:Z|[+-](?:0\d|1\d|2[0-3])(?::?[0-5]\d)?)$/u, pe = /^\d{4}-W(?:0[1-9]|[1-4]\d|5[0-3])$/u, oe = /^(?:[\da-f]{2}:){5}[\da-f]{2}$|^(?:[\da-f]{2}-){5}[\da-f]{2}$|^(?:[\da-f]{4}\.){2}[\da-f]{4}$/iu, ye = /^(?:[\da-f]{2}:){7}[\da-f]{2}$|^(?:[\da-f]{2}-){7}[\da-f]{2}$|^(?:[\da-f]{4}\.){3}[\da-f]{4}$|^(?:[\da-f]{4}:){3}[\da-f]{4}$/iu, ae = /^(?:[\da-f]{2}:){5}[\da-f]{2}$|^(?:[\da-f]{2}-){5}[\da-f]{2}$|^(?:[\da-f]{4}\.){2}[\da-f]{4}$|^(?:[\da-f]{2}:){7}[\da-f]{2}$|^(?:[\da-f]{2}-){7}[\da-f]{2}$|^(?:[\da-f]{4}\.){3}[\da-f]{4}$|^(?:[\da-f]{4}:){3}[\da-f]{4}$/iu, he = /^[\w-]+$/u, ve = /^(?:0o)?[0-7]+$/iu, me = /^[\da-hjkmnp-tv-z]{26}$/iu, _e = /^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/iu, k;
function wi(r) {
  k = { ...k, ...r };
}
function j(r) {
  return {
    lang: (r == null ? void 0 : r.lang) ?? (k == null ? void 0 : k.lang),
    message: r == null ? void 0 : r.message,
    abortEarly: (r == null ? void 0 : r.abortEarly) ?? (k == null ? void 0 : k.abortEarly),
    abortPipeEarly: (r == null ? void 0 : r.abortPipeEarly) ?? (k == null ? void 0 : k.abortPipeEarly)
  };
}
function Ai() {
  k = void 0;
}
var E;
function $i(r, n) {
  E || (E = /* @__PURE__ */ new Map()), E.set(n, r);
}
function ke(r) {
  return E == null ? void 0 : E.get(r);
}
function Di(r) {
  E == null || E.delete(r);
}
var w;
function Ii(r, n) {
  w || (w = /* @__PURE__ */ new Map()), w.set(n, r);
}
function be(r) {
  return w == null ? void 0 : w.get(r);
}
function ji(r) {
  w == null || w.delete(r);
}
var b;
function qi(r, n, e) {
  b || (b = /* @__PURE__ */ new Map()), b.get(r) || b.set(r, /* @__PURE__ */ new Map()), b.get(r).set(e, n);
}
function de(r, n) {
  var e;
  return (e = b == null ? void 0 : b.get(r)) == null ? void 0 : e.get(n);
}
function Oi(r, n) {
  var e;
  (e = b == null ? void 0 : b.get(r)) == null || e.delete(n);
}
function _(r) {
  var e, i;
  const n = typeof r;
  return n === "string" ? `"${r}"` : n === "number" || n === "bigint" || n === "boolean" ? `${r}` : n === "object" || n === "function" ? (r && ((i = (e = Object.getPrototypeOf(r)) == null ? void 0 : e.constructor) == null ? void 0 : i.name)) ?? "null" : n;
}
function o(r, n, e, i, u) {
  const s = u && "input" in u ? u.input : e.value, l = (u == null ? void 0 : u.expected) ?? r.expects ?? null, f = (u == null ? void 0 : u.received) ?? _(s), t = {
    kind: r.kind,
    type: r.type,
    input: s,
    expected: l,
    received: f,
    message: `Invalid ${n}: ${l ? `Expected ${l} but r` : "R"}eceived ${f}`,
    requirement: r.requirement,
    path: u == null ? void 0 : u.path,
    issues: u == null ? void 0 : u.issues,
    lang: i.lang,
    abortEarly: i.abortEarly,
    abortPipeEarly: i.abortPipeEarly
  }, p = r.kind === "schema", c = (u == null ? void 0 : u.message) ?? r.message ?? de(r.reference, t.lang) ?? (p ? be(t.lang) : null) ?? i.message ?? ke(t.lang);
  c && (t.message = typeof c == "function" ? (
    // @ts-expect-error
    c(t)
  ) : c), p && (e.typed = !1), e.issues ? e.issues.push(t) : e.issues = [t];
}
var xe = /\D/gu;
function z(r) {
  const n = r.replace(xe, "");
  let e = n.length, i = 1, u = 0;
  for (; e; ) {
    const s = +n[--e];
    i ^= 1, u += i ? [0, 2, 4, 6, 8, 1, 3, 5, 7, 9][s] : s;
  }
  return u % 10 === 0;
}
function $(r, n) {
  return Object.hasOwn(r, n) && n !== "__proto__" && n !== "prototype" && n !== "constructor";
}
function A(r, n) {
  const e = [...new Set(r)];
  return e.length > 1 ? `(${e.join(` ${n} `)})` : e[0] ?? "never";
}
function gi(r, n) {
  const e = {};
  for (const i of r)
    e[i] = n;
  return e;
}
function Ee(r) {
  if (r.path) {
    let n = "";
    for (const e of r.path)
      if (typeof e.key == "string" || typeof e.key == "number")
        n ? n += `.${e.key}` : n += e.key;
      else
        return null;
    return n;
  }
  return null;
}
function Pi(r, n) {
  return n.kind === r;
}
function Si(r, n) {
  return n.type === r;
}
function Mi(r) {
  return r instanceof O;
}
var O = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(n) {
    super(n[0].message);
    /**
     * The error issues.
     */
    g(this, "issues");
    this.name = "ValiError", this.issues = n;
  }
};
function we(r) {
  return {
    kind: "validation",
    type: "base64",
    reference: we,
    async: !1,
    expects: null,
    requirement: U,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "Base64", n, e), n;
    }
  };
}
function Ae(r) {
  return {
    kind: "validation",
    type: "bic",
    reference: Ae,
    async: !1,
    expects: null,
    requirement: W,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "BIC", n, e), n;
    }
  };
}
function $e(r) {
  return {
    kind: "transformation",
    type: "brand",
    reference: $e,
    async: !1,
    name: r,
    _run(n) {
      return n;
    }
  };
}
function De(r, n) {
  return {
    kind: "validation",
    type: "bytes",
    reference: De,
    async: !1,
    expects: `${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      if (e.typed) {
        const u = new TextEncoder().encode(e.value).length;
        u !== this.requirement && o(this, "bytes", e, i, {
          received: `${u}`
        });
      }
      return e;
    }
  };
}
function Ie(r, n) {
  return {
    kind: "validation",
    type: "check",
    reference: Ie,
    async: !1,
    expects: null,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && !this.requirement(e.value) && o(this, "input", e, i), e;
    }
  };
}
function je(r, n) {
  return {
    kind: "validation",
    type: "check",
    reference: je,
    async: !0,
    expects: null,
    requirement: r,
    message: n,
    async _run(e, i) {
      return e.typed && !await this.requirement(e.value) && o(this, "input", e, i), e;
    }
  };
}
function qe(r, n) {
  return {
    kind: "validation",
    type: "check_items",
    reference: qe,
    async: !1,
    expects: null,
    requirement: r,
    message: n,
    _run(e, i) {
      if (e.typed)
        for (let u = 0; u < e.value.length; u++) {
          const s = e.value[u];
          this.requirement(s, u, e.value) || o(this, "item", e, i, {
            input: s,
            path: [
              {
                type: "array",
                origin: "value",
                input: e.value,
                key: u,
                value: s
              }
            ]
          });
        }
      return e;
    }
  };
}
var Oe = /^(?:\d{14,19}|\d{4}(?: \d{3,6}){2,4}|\d{4}(?:-\d{3,6}){2,4})$/u, ge = /[- ]/gu, Pe = [
  // American Express
  /^3[47]\d{13}$/u,
  // Diners Club
  /^3(?:0[0-5]|[68]\d)\d{11,13}$/u,
  // Discover
  /^6(?:011|5\d{2})\d{12,15}$/u,
  // JCB
  /^(?:2131|1800|35\d{3})\d{11}$/u,
  // Mastercard
  /^5[1-5]\d{2}|(?:222\d|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)\d{12}$/u,
  // UnionPay
  /^(?:6[27]\d{14,17}|81\d{14,17})$/u,
  // Visa
  /^4\d{12}(?:\d{3,6})?$/u
];
function Se(r) {
  return {
    kind: "validation",
    type: "credit_card",
    reference: Se,
    async: !1,
    expects: null,
    requirement(n) {
      let e;
      return Oe.test(n) && // Remove any hyphens and blanks
      (e = n.replace(ge, "")) && // Check if it matches a provider
      Pe.some((i) => i.test(e)) && // Check if passes luhn algorithm
      z(e);
    },
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement(n.value) && o(this, "credit card", n, e), n;
    }
  };
}
function Me(r) {
  return {
    kind: "validation",
    type: "cuid2",
    reference: Me,
    async: !1,
    expects: null,
    requirement: J,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "Cuid2", n, e), n;
    }
  };
}
function Re(r) {
  return {
    kind: "validation",
    type: "decimal",
    reference: Re,
    async: !1,
    expects: null,
    requirement: K,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "decimal", n, e), n;
    }
  };
}
function ze(r) {
  return {
    kind: "metadata",
    type: "description",
    reference: ze,
    description: r
  };
}
function Ge(r) {
  return {
    kind: "validation",
    type: "digits",
    reference: Ge,
    async: !1,
    expects: null,
    requirement: H,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "digits", n, e), n;
    }
  };
}
function Ne(r) {
  return {
    kind: "validation",
    type: "email",
    reference: Ne,
    expects: null,
    async: !1,
    requirement: Z,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "email", n, e), n;
    }
  };
}
function Te(r) {
  return {
    kind: "validation",
    type: "emoji",
    reference: Te,
    async: !1,
    expects: null,
    requirement: Q,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "emoji", n, e), n;
    }
  };
}
function Xe(r) {
  return {
    kind: "validation",
    type: "empty",
    reference: Xe,
    async: !1,
    expects: "0",
    message: r,
    _run(n, e) {
      return n.typed && n.value.length > 0 && o(this, "length", n, e, {
        received: `${n.value.length}`
      }), n;
    }
  };
}
function Ce(r, n) {
  return {
    kind: "validation",
    type: "ends_with",
    reference: Ce,
    async: !1,
    expects: `"${r}"`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && !e.value.endsWith(this.requirement) && o(this, "end", e, i, {
        received: `"${e.value.slice(-this.requirement.length)}"`
      }), e;
    }
  };
}
function Ve(r, n) {
  return {
    kind: "validation",
    type: "every_item",
    reference: Ve,
    async: !1,
    expects: null,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && !e.value.every(this.requirement) && o(this, "item", e, i), e;
    }
  };
}
function Fe(r, n) {
  const e = _(r);
  return {
    kind: "validation",
    type: "excludes",
    reference: Fe,
    async: !1,
    expects: `!${e}`,
    requirement: r,
    message: n,
    _run(i, u) {
      return i.typed && i.value.includes(this.requirement) && o(this, "content", i, u, { received: e }), i;
    }
  };
}
function Le(r) {
  return {
    kind: "transformation",
    type: "filter_items",
    reference: Le,
    async: !1,
    operation: r,
    _run(n) {
      return n.value = n.value.filter(this.operation), n;
    }
  };
}
function Be(r) {
  return {
    kind: "transformation",
    type: "find_item",
    reference: Be,
    async: !1,
    operation: r,
    _run(n) {
      return n.value = n.value.find(this.operation), n;
    }
  };
}
function Ue(r) {
  return {
    kind: "validation",
    type: "finite",
    reference: Ue,
    async: !1,
    expects: null,
    requirement: Number.isFinite,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement(n.value) && o(this, "finite", n, e), n;
    }
  };
}
var We = {
  md4: 32,
  md5: 32,
  sha1: 40,
  sha256: 64,
  sha384: 96,
  sha512: 128,
  ripemd128: 32,
  ripemd160: 40,
  tiger128: 32,
  tiger160: 40,
  tiger192: 48,
  crc32: 8,
  crc32b: 8,
  adler32: 8
};
function Je(r, n) {
  return {
    kind: "validation",
    type: "hash",
    reference: Je,
    expects: null,
    async: !1,
    requirement: RegExp(
      r.map((e) => `^[a-f0-9]{${We[e]}}$`).join("|"),
      "iu"
    ),
    message: n,
    _run(e, i) {
      return e.typed && !this.requirement.test(e.value) && o(this, "hash", e, i), e;
    }
  };
}
function Ke(r) {
  return {
    kind: "validation",
    type: "hexadecimal",
    reference: Ke,
    async: !1,
    expects: null,
    requirement: Y,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "hexadecimal", n, e), n;
    }
  };
}
function He(r) {
  return {
    kind: "validation",
    type: "hex_color",
    reference: He,
    async: !1,
    expects: null,
    requirement: ee,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "hex color", n, e), n;
    }
  };
}
function Ze(r) {
  return {
    kind: "validation",
    type: "imei",
    reference: Ze,
    async: !1,
    expects: null,
    requirement(n) {
      return ne.test(n) && z(n);
    },
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement(n.value) && o(this, "IMEI", n, e), n;
    }
  };
}
function Qe(r, n) {
  const e = _(r);
  return {
    kind: "validation",
    type: "includes",
    reference: Qe,
    async: !1,
    expects: e,
    requirement: r,
    message: n,
    _run(i, u) {
      return i.typed && !i.value.includes(this.requirement) && o(this, "content", i, u, {
        received: `!${e}`
      }), i;
    }
  };
}
function Ye(r) {
  return {
    kind: "validation",
    type: "integer",
    reference: Ye,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement(n.value) && o(this, "integer", n, e), n;
    }
  };
}
function en(r) {
  return {
    kind: "validation",
    type: "ip",
    reference: en,
    async: !1,
    expects: null,
    requirement: ue,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "IP", n, e), n;
    }
  };
}
function nn(r) {
  return {
    kind: "validation",
    type: "ipv4",
    reference: nn,
    async: !1,
    expects: null,
    requirement: re,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "IPv4", n, e), n;
    }
  };
}
function rn(r) {
  return {
    kind: "validation",
    type: "ipv6",
    reference: rn,
    async: !1,
    expects: null,
    requirement: ie,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "IPv6", n, e), n;
    }
  };
}
function un(r) {
  return {
    kind: "validation",
    type: "iso_date",
    reference: un,
    async: !1,
    expects: null,
    requirement: se,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "date", n, e), n;
    }
  };
}
function sn(r) {
  return {
    kind: "validation",
    type: "iso_date_time",
    reference: sn,
    async: !1,
    expects: null,
    requirement: te,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "date-time", n, e), n;
    }
  };
}
function tn(r) {
  return {
    kind: "validation",
    type: "iso_time",
    reference: tn,
    async: !1,
    expects: null,
    requirement: le,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "time", n, e), n;
    }
  };
}
function ln(r) {
  return {
    kind: "validation",
    type: "iso_time_second",
    reference: ln,
    async: !1,
    expects: null,
    requirement: fe,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "time-second", n, e), n;
    }
  };
}
function fn(r) {
  return {
    kind: "validation",
    type: "iso_timestamp",
    reference: fn,
    async: !1,
    expects: null,
    requirement: ce,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "timestamp", n, e), n;
    }
  };
}
function cn(r) {
  return {
    kind: "validation",
    type: "iso_week",
    reference: cn,
    async: !1,
    expects: null,
    requirement: pe,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "week", n, e), n;
    }
  };
}
function pn(r, n) {
  return {
    kind: "validation",
    type: "length",
    reference: pn,
    async: !1,
    expects: `${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value.length !== this.requirement && o(this, "length", e, i, {
        received: `${e.value.length}`
      }), e;
    }
  };
}
function on(r) {
  return {
    kind: "validation",
    type: "mac",
    reference: on,
    async: !1,
    expects: null,
    requirement: ae,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "MAC", n, e), n;
    }
  };
}
function yn(r) {
  return {
    kind: "validation",
    type: "mac48",
    reference: yn,
    async: !1,
    expects: null,
    requirement: oe,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "48-bit MAC", n, e), n;
    }
  };
}
function an(r) {
  return {
    kind: "validation",
    type: "mac64",
    reference: an,
    async: !1,
    expects: null,
    requirement: ye,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "64-bit MAC", n, e), n;
    }
  };
}
function hn(r) {
  return {
    kind: "transformation",
    type: "map_items",
    reference: hn,
    async: !1,
    operation: r,
    _run(n) {
      return n.value = n.value.map(this.operation), n;
    }
  };
}
function vn(r, n) {
  return {
    kind: "validation",
    type: "max_bytes",
    reference: vn,
    async: !1,
    expects: `<=${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      if (e.typed) {
        const u = new TextEncoder().encode(e.value).length;
        u > this.requirement && o(this, "bytes", e, i, {
          received: `${u}`
        });
      }
      return e;
    }
  };
}
function mn(r, n) {
  return {
    kind: "validation",
    type: "max_length",
    reference: mn,
    async: !1,
    expects: `<=${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value.length > this.requirement && o(this, "length", e, i, {
        received: `${e.value.length}`
      }), e;
    }
  };
}
function _n(r, n) {
  return {
    kind: "validation",
    type: "max_size",
    reference: _n,
    async: !1,
    expects: `<=${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value.size > this.requirement && o(this, "size", e, i, {
        received: `${e.value.size}`
      }), e;
    }
  };
}
function kn(r, n) {
  return {
    kind: "validation",
    type: "max_value",
    reference: kn,
    async: !1,
    expects: `<=${r instanceof Date ? r.toJSON() : _(r)}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value > this.requirement && o(this, "value", e, i, {
        received: e.value instanceof Date ? e.value.toJSON() : _(e.value)
      }), e;
    }
  };
}
function bn(r) {
  return {
    kind: "metadata",
    type: "metadata",
    reference: bn,
    metadata: r
  };
}
function dn(r, n) {
  return {
    kind: "validation",
    type: "mime_type",
    reference: dn,
    async: !1,
    expects: A(
      r.map((e) => `"${e}"`),
      "|"
    ),
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && !this.requirement.includes(e.value.type) && o(this, "MIME type", e, i, {
        received: `"${e.value.type}"`
      }), e;
    }
  };
}
function xn(r, n) {
  return {
    kind: "validation",
    type: "min_bytes",
    reference: xn,
    async: !1,
    expects: `>=${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      if (e.typed) {
        const u = new TextEncoder().encode(e.value).length;
        u < this.requirement && o(this, "bytes", e, i, {
          received: `${u}`
        });
      }
      return e;
    }
  };
}
function En(r, n) {
  return {
    kind: "validation",
    type: "min_length",
    reference: En,
    async: !1,
    expects: `>=${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value.length < this.requirement && o(this, "length", e, i, {
        received: `${e.value.length}`
      }), e;
    }
  };
}
function wn(r, n) {
  return {
    kind: "validation",
    type: "min_size",
    reference: wn,
    async: !1,
    expects: `>=${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value.size < this.requirement && o(this, "size", e, i, {
        received: `${e.value.size}`
      }), e;
    }
  };
}
function An(r, n) {
  return {
    kind: "validation",
    type: "min_value",
    reference: An,
    async: !1,
    expects: `>=${r instanceof Date ? r.toJSON() : _(r)}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value < this.requirement && o(this, "value", e, i, {
        received: e.value instanceof Date ? e.value.toJSON() : _(e.value)
      }), e;
    }
  };
}
function $n(r, n) {
  return {
    kind: "validation",
    type: "multiple_of",
    reference: $n,
    async: !1,
    expects: `%${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value % this.requirement !== 0 && o(this, "multiple", e, i), e;
    }
  };
}
function Dn(r) {
  return {
    kind: "validation",
    type: "nanoid",
    reference: Dn,
    async: !1,
    expects: null,
    requirement: he,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "Nano ID", n, e), n;
    }
  };
}
function In(r) {
  return {
    kind: "validation",
    type: "non_empty",
    reference: In,
    async: !1,
    expects: "!0",
    message: r,
    _run(n, e) {
      return n.typed && n.value.length === 0 && o(this, "length", n, e, {
        received: "0"
      }), n;
    }
  };
}
function jn(r) {
  return {
    kind: "transformation",
    type: "normalize",
    reference: jn,
    async: !1,
    form: r,
    _run(n) {
      return n.value = n.value.normalize(this.form), n;
    }
  };
}
function qn(r, n) {
  return {
    kind: "validation",
    type: "not_bytes",
    reference: qn,
    async: !1,
    expects: `!${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      if (e.typed) {
        const u = new TextEncoder().encode(e.value).length;
        u === this.requirement && o(this, "bytes", e, i, {
          received: `${u}`
        });
      }
      return e;
    }
  };
}
function On(r, n) {
  return {
    kind: "validation",
    type: "not_length",
    reference: On,
    async: !1,
    expects: `!${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value.length === this.requirement && o(this, "length", e, i, {
        received: `${e.value.length}`
      }), e;
    }
  };
}
function gn(r, n) {
  return {
    kind: "validation",
    type: "not_size",
    reference: gn,
    async: !1,
    expects: `!${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value.size === this.requirement && o(this, "size", e, i, {
        received: `${e.value.size}`
      }), e;
    }
  };
}
function Pn(r, n) {
  return {
    kind: "validation",
    type: "not_value",
    reference: Pn,
    async: !1,
    expects: r instanceof Date ? `!${r.toJSON()}` : `!${_(r)}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && this.requirement <= e.value && this.requirement >= e.value && o(this, "value", e, i, {
        received: e.value instanceof Date ? e.value.toJSON() : _(e.value)
      }), e;
    }
  };
}
function Sn(r) {
  return {
    kind: "validation",
    type: "octal",
    reference: Sn,
    async: !1,
    expects: null,
    requirement: ve,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "octal", n, e), n;
    }
  };
}
function G(r, n) {
  var e;
  if (r.issues)
    for (const i of n)
      for (const u of r.issues) {
        let s = !1;
        const l = Math.min(i.length, ((e = u.path) == null ? void 0 : e.length) ?? 0);
        for (let f = 0; f < l; f++)
          if (i[f] !== u.path[f].key) {
            s = !0;
            break;
          }
        if (!s)
          return !1;
      }
  return !0;
}
function Mn(r, n, e) {
  return {
    kind: "validation",
    type: "partial_check",
    reference: Mn,
    async: !1,
    expects: null,
    requirement: n,
    message: e,
    _run(i, u) {
      return G(i, r) && // @ts-expect-error
      !this.requirement(i.value) && o(this, "input", i, u), i;
    }
  };
}
function Rn(r, n, e) {
  return {
    kind: "validation",
    type: "partial_check",
    reference: Rn,
    async: !0,
    expects: null,
    requirement: n,
    message: e,
    async _run(i, u) {
      return G(i, r) && // @ts-expect-error
      !await this.requirement(i.value) && o(this, "input", i, u), i;
    }
  };
}
function zn(r) {
  return {
    kind: "validation",
    type: "raw_check",
    reference: zn,
    async: !1,
    expects: null,
    _run(n, e) {
      return r({
        dataset: n,
        config: e,
        addIssue: (i) => o(this, (i == null ? void 0 : i.label) ?? "input", n, e, i)
      }), n;
    }
  };
}
function Gn(r) {
  return {
    kind: "validation",
    type: "raw_check",
    reference: Gn,
    async: !0,
    expects: null,
    async _run(n, e) {
      return await r({
        dataset: n,
        config: e,
        addIssue: (i) => o(this, (i == null ? void 0 : i.label) ?? "input", n, e, i)
      }), n;
    }
  };
}
function Nn(r) {
  return {
    kind: "transformation",
    type: "raw_transform",
    reference: Nn,
    async: !1,
    _run(n, e) {
      const i = r({
        dataset: n,
        config: e,
        addIssue: (u) => o(this, (u == null ? void 0 : u.label) ?? "input", n, e, u),
        NEVER: null
      });
      return n.issues ? n.typed = !1 : n.value = i, n;
    }
  };
}
function Tn(r) {
  return {
    kind: "transformation",
    type: "raw_transform",
    reference: Tn,
    async: !0,
    async _run(n, e) {
      const i = await r({
        dataset: n,
        config: e,
        addIssue: (u) => o(this, (u == null ? void 0 : u.label) ?? "input", n, e, u),
        NEVER: null
      });
      return n.issues ? n.typed = !1 : n.value = i, n;
    }
  };
}
function Xn() {
  return {
    kind: "transformation",
    type: "readonly",
    reference: Xn,
    async: !1,
    _run(r) {
      return r;
    }
  };
}
function Cn(r, n) {
  return {
    kind: "transformation",
    type: "reduce_items",
    reference: Cn,
    async: !1,
    operation: r,
    initial: n,
    _run(e) {
      return e.value = e.value.reduce(this.operation, this.initial), e;
    }
  };
}
function Vn(r, n) {
  return {
    kind: "validation",
    type: "regex",
    reference: Vn,
    async: !1,
    expects: `${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && !this.requirement.test(e.value) && o(this, "format", e, i), e;
    }
  };
}
function Fn(r) {
  return {
    kind: "validation",
    type: "safe_integer",
    reference: Fn,
    async: !1,
    expects: null,
    requirement: Number.isSafeInteger,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement(n.value) && o(this, "safe integer", n, e), n;
    }
  };
}
function Ln(r, n) {
  return {
    kind: "validation",
    type: "size",
    reference: Ln,
    async: !1,
    expects: `${r}`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && e.value.size !== this.requirement && o(this, "size", e, i, {
        received: `${e.value.size}`
      }), e;
    }
  };
}
function Bn(r, n) {
  return {
    kind: "validation",
    type: "some_item",
    reference: Bn,
    async: !1,
    expects: null,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && !e.value.some(this.requirement) && o(this, "item", e, i), e;
    }
  };
}
function Un(r) {
  return {
    kind: "transformation",
    type: "sort_items",
    reference: Un,
    async: !1,
    operation: r,
    _run(n) {
      return n.value = n.value.sort(this.operation), n;
    }
  };
}
function Wn(r, n) {
  return {
    kind: "validation",
    type: "starts_with",
    reference: Wn,
    async: !1,
    expects: `"${r}"`,
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && !e.value.startsWith(this.requirement) && o(this, "start", e, i, {
        received: `"${e.value.slice(0, this.requirement.length)}"`
      }), e;
    }
  };
}
function Jn(r) {
  return {
    kind: "metadata",
    type: "title",
    reference: Jn,
    title: r
  };
}
function Kn() {
  return {
    kind: "transformation",
    type: "to_lower_case",
    reference: Kn,
    async: !1,
    _run(r) {
      return r.value = r.value.toLowerCase(), r;
    }
  };
}
function Hn(r) {
  return {
    kind: "transformation",
    type: "to_max_value",
    reference: Hn,
    async: !1,
    requirement: r,
    _run(n) {
      return n.value = n.value > this.requirement ? this.requirement : n.value, n;
    }
  };
}
function Zn(r) {
  return {
    kind: "transformation",
    type: "to_min_value",
    reference: Zn,
    async: !1,
    requirement: r,
    _run(n) {
      return n.value = n.value < this.requirement ? this.requirement : n.value, n;
    }
  };
}
function Qn() {
  return {
    kind: "transformation",
    type: "to_upper_case",
    reference: Qn,
    async: !1,
    _run(r) {
      return r.value = r.value.toUpperCase(), r;
    }
  };
}
function Yn(r) {
  return {
    kind: "transformation",
    type: "transform",
    reference: Yn,
    async: !1,
    operation: r,
    _run(n) {
      return n.value = this.operation(n.value), n;
    }
  };
}
function er(r) {
  return {
    kind: "transformation",
    type: "transform",
    reference: er,
    async: !0,
    operation: r,
    async _run(n) {
      return n.value = await this.operation(n.value), n;
    }
  };
}
function nr() {
  return {
    kind: "transformation",
    type: "trim",
    reference: nr,
    async: !1,
    _run(r) {
      return r.value = r.value.trim(), r;
    }
  };
}
function rr() {
  return {
    kind: "transformation",
    type: "trim_end",
    reference: rr,
    async: !1,
    _run(r) {
      return r.value = r.value.trimEnd(), r;
    }
  };
}
function ir() {
  return {
    kind: "transformation",
    type: "trim_start",
    reference: ir,
    async: !1,
    _run(r) {
      return r.value = r.value.trimStart(), r;
    }
  };
}
function ur(r) {
  return {
    kind: "validation",
    type: "ulid",
    reference: ur,
    async: !1,
    expects: null,
    requirement: me,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "ULID", n, e), n;
    }
  };
}
function sr(r) {
  return {
    kind: "validation",
    type: "url",
    reference: sr,
    async: !1,
    expects: null,
    requirement(n) {
      try {
        return new URL(n), !0;
      } catch {
        return !1;
      }
    },
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement(n.value) && o(this, "URL", n, e), n;
    }
  };
}
function tr(r) {
  return {
    kind: "validation",
    type: "uuid",
    reference: tr,
    async: !1,
    expects: null,
    requirement: _e,
    message: r,
    _run(n, e) {
      return n.typed && !this.requirement.test(n.value) && o(this, "UUID", n, e), n;
    }
  };
}
function lr(r, n) {
  return {
    kind: "validation",
    type: "value",
    reference: lr,
    async: !1,
    expects: r instanceof Date ? r.toJSON() : _(r),
    requirement: r,
    message: n,
    _run(e, i) {
      return e.typed && !(this.requirement <= e.value && this.requirement >= e.value) && o(this, "value", e, i, {
        received: e.value instanceof Date ? e.value.toJSON() : _(e.value)
      }), e;
    }
  };
}
function Ri(r, n) {
  return {
    ...r,
    _run(e, i) {
      return r._run(e, { ...i, ...n });
    }
  };
}
function q(r, n, e) {
  return typeof r.fallback == "function" ? (
    // @ts-expect-error
    r.fallback(n, e)
  ) : (
    // @ts-expect-error
    r.fallback
  );
}
function zi(r, n) {
  return {
    ...r,
    fallback: n,
    _run(e, i) {
      const u = r._run(e, i);
      return u.issues ? { typed: !0, value: q(this, u, i) } : u;
    }
  };
}
function Gi(r, n) {
  return {
    ...r,
    fallback: n,
    async: !0,
    async _run(e, i) {
      const u = await r._run(e, i);
      return u.issues ? (
        // @ts-expect-error
        { typed: !0, value: await q(this, u, i) }
      ) : u;
    }
  };
}
function Ni(r) {
  const n = {};
  for (const e of r)
    if (e.path) {
      const i = Ee(e);
      i ? (n.nested || (n.nested = {}), n.nested[i] ? n.nested[i].push(e.message) : n.nested[i] = [e.message]) : n.other ? n.other.push(e.message) : n.other = [e.message];
    } else
      n.root ? n.root.push(e.message) : n.root = [e.message];
  return n;
}
function Ti(r, n) {
  return {
    ...r,
    _run(e, i) {
      const u = e.issues && [...e.issues];
      if (r._run(e, i), e.issues) {
        for (const s of e.issues)
          if (!(u != null && u.includes(s))) {
            let l = e.value;
            for (const f of n) {
              const t = l[f], p = {
                type: "unknown",
                origin: "value",
                input: l,
                key: f,
                value: t
              };
              if (s.path ? s.path.push(p) : s.path = [p], !t)
                break;
              l = t;
            }
          }
      }
      return e;
    }
  };
}
function Xi(r, n) {
  return {
    ...r,
    async: !0,
    async _run(e, i) {
      const u = e.issues && [...e.issues];
      if (await r._run(e, i), e.issues) {
        for (const s of e.issues)
          if (!(u != null && u.includes(s))) {
            let l = e.value;
            for (const f of n) {
              const t = l[f], p = {
                type: "unknown",
                origin: "value",
                input: l,
                key: f,
                value: t
              };
              if (s.path ? s.path.push(p) : s.path = [p], !t)
                break;
              l = t;
            }
          }
      }
      return e;
    }
  };
}
function d(r, n, e) {
  return typeof r.default == "function" ? (
    // @ts-expect-error
    r.default(n, e)
  ) : (
    // @ts-expect-error
    r.default
  );
}
function P(r) {
  if ("entries" in r) {
    const n = {};
    for (const e in r.entries)
      n[e] = P(r.entries[e]);
    return n;
  }
  return "items" in r ? r.items.map(P) : d(r);
}
async function S(r) {
  return "entries" in r ? Object.fromEntries(
    await Promise.all(
      Object.entries(r.entries).map(async ([n, e]) => [
        n,
        await S(e)
      ])
    )
  ) : "items" in r ? Promise.all(r.items.map(S)) : d(r);
}
function M(r) {
  if ("entries" in r) {
    const n = {};
    for (const e in r.entries)
      n[e] = M(r.entries[e]);
    return n;
  }
  return "items" in r ? r.items.map(M) : q(r);
}
async function R(r) {
  return "entries" in r ? Object.fromEntries(
    await Promise.all(
      Object.entries(r.entries).map(async ([n, e]) => [
        n,
        await R(e)
      ])
    )
  ) : "items" in r ? Promise.all(r.items.map(R)) : q(r);
}
function Ci(r, n) {
  return !r._run({ typed: !1, value: n }, { abortEarly: !0 }).issues;
}
function fr() {
  return {
    kind: "schema",
    type: "any",
    reference: fr,
    expects: "any",
    async: !1,
    _run(r) {
      return r.typed = !0, r;
    }
  };
}
function cr(r, n) {
  return {
    kind: "schema",
    type: "array",
    reference: cr,
    expects: "Array",
    async: !1,
    item: r,
    message: n,
    _run(e, i) {
      var s;
      const u = e.value;
      if (Array.isArray(u)) {
        e.typed = !0, e.value = [];
        for (let l = 0; l < u.length; l++) {
          const f = u[l], t = this.item._run({ typed: !1, value: f }, i);
          if (t.issues) {
            const p = {
              type: "array",
              origin: "value",
              input: u,
              key: l,
              value: f
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), e.value.push(t.value);
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function pr(r, n) {
  return {
    kind: "schema",
    type: "array",
    reference: pr,
    expects: "Array",
    async: !0,
    item: r,
    message: n,
    async _run(e, i) {
      var s;
      const u = e.value;
      if (Array.isArray(u)) {
        e.typed = !0, e.value = [];
        const l = await Promise.all(
          u.map((f) => this.item._run({ typed: !1, value: f }, i))
        );
        for (let f = 0; f < l.length; f++) {
          const t = l[f];
          if (t.issues) {
            const p = {
              type: "array",
              origin: "value",
              input: u,
              key: f,
              value: u[f]
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), e.value.push(t.value);
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function or(r) {
  return {
    kind: "schema",
    type: "bigint",
    reference: or,
    expects: "bigint",
    async: !1,
    message: r,
    _run(n, e) {
      return typeof n.value == "bigint" ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function yr(r) {
  return {
    kind: "schema",
    type: "blob",
    reference: yr,
    expects: "Blob",
    async: !1,
    message: r,
    _run(n, e) {
      return n.value instanceof Blob ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function ar(r) {
  return {
    kind: "schema",
    type: "boolean",
    reference: ar,
    expects: "boolean",
    async: !1,
    message: r,
    _run(n, e) {
      return typeof n.value == "boolean" ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function hr(r, n) {
  return {
    kind: "schema",
    type: "custom",
    reference: hr,
    expects: "unknown",
    async: !1,
    check: r,
    message: n,
    _run(e, i) {
      return this.check(e.value) ? e.typed = !0 : o(this, "type", e, i), e;
    }
  };
}
function vr(r, n) {
  return {
    kind: "schema",
    type: "custom",
    reference: vr,
    expects: "unknown",
    async: !0,
    check: r,
    message: n,
    async _run(e, i) {
      return await this.check(e.value) ? e.typed = !0 : o(this, "type", e, i), e;
    }
  };
}
function mr(r) {
  return {
    kind: "schema",
    type: "date",
    reference: mr,
    expects: "Date",
    async: !1,
    message: r,
    _run(n, e) {
      return n.value instanceof Date ? isNaN(n.value) ? o(this, "type", n, e, {
        received: '"Invalid Date"'
      }) : n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function _r(r, n) {
  const e = Object.entries(r).filter(([i]) => isNaN(+i)).map(([, i]) => i);
  return {
    kind: "schema",
    type: "enum",
    reference: _r,
    expects: A(e.map(_), "|"),
    async: !1,
    enum: r,
    options: e,
    message: n,
    _run(i, u) {
      return this.options.includes(i.value) ? i.typed = !0 : o(this, "type", i, u), i;
    }
  };
}
function kr(r) {
  return {
    kind: "schema",
    type: "file",
    reference: kr,
    expects: "File",
    async: !1,
    message: r,
    _run(n, e) {
      return n.value instanceof File ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function br(r) {
  return {
    kind: "schema",
    type: "function",
    reference: br,
    expects: "Function",
    async: !1,
    message: r,
    _run(n, e) {
      return typeof n.value == "function" ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function dr(r, n) {
  return {
    kind: "schema",
    type: "instance",
    reference: dr,
    expects: r.name,
    async: !1,
    class: r,
    message: n,
    _run(e, i) {
      return e.value instanceof this.class ? e.typed = !0 : o(this, "type", e, i), e;
    }
  };
}
function D(r, n) {
  if (typeof r == typeof n) {
    if (r === n || r instanceof Date && n instanceof Date && +r == +n)
      return { value: r };
    if (r && n && r.constructor === Object && n.constructor === Object) {
      for (const e in n)
        if (e in r) {
          const i = D(r[e], n[e]);
          if (i.issue)
            return i;
          r[e] = i.value;
        } else
          r[e] = n[e];
      return { value: r };
    }
    if (Array.isArray(r) && Array.isArray(n) && r.length === n.length) {
      for (let e = 0; e < r.length; e++) {
        const i = D(r[e], n[e]);
        if (i.issue)
          return i;
        r[e] = i.value;
      }
      return { value: r };
    }
  }
  return { issue: !0 };
}
function xr(r, n) {
  return {
    kind: "schema",
    type: "intersect",
    reference: xr,
    expects: A(
      r.map((e) => e.expects),
      "&"
    ),
    async: !1,
    options: r,
    message: n,
    _run(e, i) {
      if (this.options.length) {
        const u = e.value;
        let s;
        e.typed = !0;
        for (const l of this.options) {
          const f = l._run(
            { typed: !1, value: u },
            i
          );
          if (f.issues && (e.issues ? e.issues.push(...f.issues) : e.issues = f.issues, i.abortEarly)) {
            e.typed = !1;
            break;
          }
          f.typed || (e.typed = !1), e.typed && (s ? s.push(f.value) : s = [f.value]);
        }
        if (e.typed) {
          e.value = s[0];
          for (let l = 1; l < s.length; l++) {
            const f = D(e.value, s[l]);
            if (f.issue) {
              o(this, "type", e, i, {
                received: "unknown"
              });
              break;
            }
            e.value = f.value;
          }
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function Er(r, n) {
  return {
    kind: "schema",
    type: "intersect",
    reference: Er,
    expects: A(
      r.map((e) => e.expects),
      "&"
    ),
    async: !0,
    options: r,
    message: n,
    async _run(e, i) {
      if (this.options.length) {
        const u = e.value;
        let s;
        e.typed = !0;
        const l = await Promise.all(
          this.options.map(
            (f) => f._run({ typed: !1, value: u }, i)
          )
        );
        for (const f of l) {
          if (f.issues && (e.issues ? e.issues.push(...f.issues) : e.issues = f.issues, i.abortEarly)) {
            e.typed = !1;
            break;
          }
          f.typed || (e.typed = !1), e.typed && (s ? s.push(f.value) : s = [f.value]);
        }
        if (e.typed) {
          e.value = s[0];
          for (let f = 1; f < s.length; f++) {
            const t = D(e.value, s[f]);
            if (t.issue) {
              o(this, "type", e, i, {
                received: "unknown"
              });
              break;
            }
            e.value = t.value;
          }
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function wr(r) {
  return {
    kind: "schema",
    type: "lazy",
    reference: wr,
    expects: "unknown",
    async: !1,
    getter: r,
    _run(n, e) {
      return this.getter(n.value)._run(n, e);
    }
  };
}
function Ar(r) {
  return {
    kind: "schema",
    type: "lazy",
    reference: Ar,
    expects: "unknown",
    async: !0,
    getter: r,
    async _run(n, e) {
      return (await this.getter(n.value))._run(n, e);
    }
  };
}
function $r(r, n) {
  return {
    kind: "schema",
    type: "literal",
    reference: $r,
    expects: _(r),
    async: !1,
    literal: r,
    message: n,
    _run(e, i) {
      return e.value === this.literal ? e.typed = !0 : o(this, "type", e, i), e;
    }
  };
}
function Dr(r, n) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: Dr,
    expects: "Object",
    async: !1,
    entries: r,
    message: n,
    _run(e, i) {
      var s;
      const u = e.value;
      if (u && typeof u == "object") {
        e.typed = !0, e.value = {};
        for (const l in this.entries) {
          const f = u[l], t = this.entries[l]._run(
            { typed: !1, value: f },
            i
          );
          if (t.issues) {
            const p = {
              type: "object",
              origin: "value",
              input: u,
              key: l,
              value: f
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), (t.value !== void 0 || l in u) && (e.value[l] = t.value);
        }
        if (!e.issues || !i.abortEarly)
          for (const l in u)
            $(u, l) && !(l in this.entries) && (e.value[l] = u[l]);
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function Ir(r, n) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: Ir,
    expects: "Object",
    async: !0,
    entries: r,
    message: n,
    async _run(e, i) {
      var s;
      const u = e.value;
      if (u && typeof u == "object") {
        e.typed = !0, e.value = {};
        const l = await Promise.all(
          Object.entries(this.entries).map(async ([f, t]) => {
            const p = u[f];
            return [
              f,
              p,
              await t._run({ typed: !1, value: p }, i)
            ];
          })
        );
        for (const [f, t, p] of l) {
          if (p.issues) {
            const c = {
              type: "object",
              origin: "value",
              input: u,
              key: f,
              value: t
            };
            for (const y of p.issues)
              y.path ? y.path.unshift(c) : y.path = [c], (s = e.issues) == null || s.push(y);
            if (e.issues || (e.issues = p.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          p.typed || (e.typed = !1), (p.value !== void 0 || f in u) && (e.value[f] = p.value);
        }
        if (!e.issues || !i.abortEarly)
          for (const f in u)
            $(u, f) && !(f in this.entries) && (e.value[f] = u[f]);
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function jr(r, n) {
  return {
    kind: "schema",
    type: "loose_tuple",
    reference: jr,
    expects: "Array",
    async: !1,
    items: r,
    message: n,
    _run(e, i) {
      var s;
      const u = e.value;
      if (Array.isArray(u)) {
        e.typed = !0, e.value = [];
        for (let l = 0; l < this.items.length; l++) {
          const f = u[l], t = this.items[l]._run(
            { typed: !1, value: f },
            i
          );
          if (t.issues) {
            const p = {
              type: "array",
              origin: "value",
              input: u,
              key: l,
              value: f
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), e.value.push(t.value);
        }
        if (!e.issues || !i.abortEarly)
          for (let l = this.items.length; l < u.length; l++)
            e.value.push(u[l]);
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function qr(r, n) {
  return {
    kind: "schema",
    type: "loose_tuple",
    reference: qr,
    expects: "Array",
    async: !0,
    items: r,
    message: n,
    async _run(e, i) {
      var s;
      const u = e.value;
      if (Array.isArray(u)) {
        e.typed = !0, e.value = [];
        const l = await Promise.all(
          this.items.map(async (f, t) => {
            const p = u[t];
            return [
              t,
              p,
              await f._run({ typed: !1, value: p }, i)
            ];
          })
        );
        for (const [f, t, p] of l) {
          if (p.issues) {
            const c = {
              type: "array",
              origin: "value",
              input: u,
              key: f,
              value: t
            };
            for (const y of p.issues)
              y.path ? y.path.unshift(c) : y.path = [c], (s = e.issues) == null || s.push(y);
            if (e.issues || (e.issues = p.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          p.typed || (e.typed = !1), e.value.push(p.value);
        }
        if (!e.issues || !i.abortEarly)
          for (let f = this.items.length; f < u.length; f++)
            e.value.push(u[f]);
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function Or(r, n, e) {
  return {
    kind: "schema",
    type: "map",
    reference: Or,
    expects: "Map",
    async: !1,
    key: r,
    value: n,
    message: e,
    _run(i, u) {
      var l, f;
      const s = i.value;
      if (s instanceof Map) {
        i.typed = !0, i.value = /* @__PURE__ */ new Map();
        for (const [t, p] of s) {
          const c = this.key._run(
            { typed: !1, value: t },
            u
          );
          if (c.issues) {
            const a = {
              type: "map",
              origin: "key",
              input: s,
              key: t,
              value: p
            };
            for (const h of c.issues)
              h.path ? h.path.unshift(a) : h.path = [a], (l = i.issues) == null || l.push(h);
            if (i.issues || (i.issues = c.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          const y = this.value._run(
            { typed: !1, value: p },
            u
          );
          if (y.issues) {
            const a = {
              type: "map",
              origin: "value",
              input: s,
              key: t,
              value: p
            };
            for (const h of y.issues)
              h.path ? h.path.unshift(a) : h.path = [a], (f = i.issues) == null || f.push(h);
            if (i.issues || (i.issues = y.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          (!c.typed || !y.typed) && (i.typed = !1), i.value.set(c.value, y.value);
        }
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function gr(r, n, e) {
  return {
    kind: "schema",
    type: "map",
    reference: gr,
    expects: "Map",
    async: !0,
    key: r,
    value: n,
    message: e,
    async _run(i, u) {
      var l, f;
      const s = i.value;
      if (s instanceof Map) {
        i.typed = !0, i.value = /* @__PURE__ */ new Map();
        const t = await Promise.all(
          [...s].map(
            ([p, c]) => Promise.all([
              p,
              c,
              this.key._run({ typed: !1, value: p }, u),
              this.value._run({ typed: !1, value: c }, u)
            ])
          )
        );
        for (const [
          p,
          c,
          y,
          a
        ] of t) {
          if (y.issues) {
            const h = {
              type: "map",
              origin: "key",
              input: s,
              key: p,
              value: c
            };
            for (const v of y.issues)
              v.path ? v.path.unshift(h) : v.path = [h], (l = i.issues) == null || l.push(v);
            if (i.issues || (i.issues = y.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          if (a.issues) {
            const h = {
              type: "map",
              origin: "value",
              input: s,
              key: p,
              value: c
            };
            for (const v of a.issues)
              v.path ? v.path.unshift(h) : v.path = [h], (f = i.issues) == null || f.push(v);
            if (i.issues || (i.issues = a.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          (!y.typed || !a.typed) && (i.typed = !1), i.value.set(y.value, a.value);
        }
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function Pr(r) {
  return {
    kind: "schema",
    type: "nan",
    reference: Pr,
    expects: "NaN",
    async: !1,
    message: r,
    _run(n, e) {
      return Number.isNaN(n.value) ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function Sr(r) {
  return {
    kind: "schema",
    type: "never",
    reference: Sr,
    expects: "never",
    async: !1,
    message: r,
    _run(n, e) {
      return o(this, "type", n, e), n;
    }
  };
}
function Mr(r, n) {
  return {
    kind: "schema",
    type: "non_nullable",
    reference: Mr,
    expects: "!null",
    async: !1,
    wrapped: r,
    message: n,
    _run(e, i) {
      return e.value === null ? (o(this, "type", e, i), e) : this.wrapped._run(e, i);
    }
  };
}
function Rr(r, n) {
  return {
    kind: "schema",
    type: "non_nullable",
    reference: Rr,
    expects: "!null",
    async: !0,
    wrapped: r,
    message: n,
    async _run(e, i) {
      return e.value === null ? (o(this, "type", e, i), e) : this.wrapped._run(e, i);
    }
  };
}
function zr(r, n) {
  return {
    kind: "schema",
    type: "non_nullish",
    reference: zr,
    expects: "(!null & !undefined)",
    async: !1,
    wrapped: r,
    message: n,
    _run(e, i) {
      return e.value === null || e.value === void 0 ? (o(this, "type", e, i), e) : this.wrapped._run(e, i);
    }
  };
}
function Gr(r, n) {
  return {
    kind: "schema",
    type: "non_nullish",
    reference: Gr,
    expects: "(!null & !undefined)",
    async: !0,
    wrapped: r,
    message: n,
    async _run(e, i) {
      return e.value === null || e.value === void 0 ? (o(this, "type", e, i), e) : this.wrapped._run(e, i);
    }
  };
}
function N(r, n) {
  return {
    kind: "schema",
    type: "non_optional",
    reference: N,
    expects: "!undefined",
    async: !1,
    wrapped: r,
    message: n,
    _run(e, i) {
      return e.value === void 0 ? (o(this, "type", e, i), e) : this.wrapped._run(e, i);
    }
  };
}
function T(r, n) {
  return {
    kind: "schema",
    type: "non_optional",
    reference: T,
    expects: "!undefined",
    async: !0,
    wrapped: r,
    message: n,
    async _run(e, i) {
      return e.value === void 0 ? (o(this, "type", e, i), e) : this.wrapped._run(e, i);
    }
  };
}
function Nr(r) {
  return {
    kind: "schema",
    type: "null",
    reference: Nr,
    expects: "null",
    async: !1,
    message: r,
    _run(n, e) {
      return n.value === null ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function Tr(r, ...n) {
  const e = {
    kind: "schema",
    type: "nullable",
    reference: Tr,
    expects: `(${r.expects} | null)`,
    async: !1,
    wrapped: r,
    _run(i, u) {
      return i.value === null && ("default" in this && (i.value = d(
        this,
        i,
        u
      )), i.value === null) ? (i.typed = !0, i) : this.wrapped._run(i, u);
    }
  };
  return 0 in n && (e.default = n[0]), e;
}
function Xr(r, ...n) {
  const e = {
    kind: "schema",
    type: "nullable",
    reference: Xr,
    expects: `(${r.expects} | null)`,
    async: !0,
    wrapped: r,
    async _run(i, u) {
      return i.value === null && ("default" in this && (i.value = await d(
        this,
        i,
        u
      )), i.value === null) ? (i.typed = !0, i) : this.wrapped._run(i, u);
    }
  };
  return 0 in n && (e.default = n[0]), e;
}
function Cr(r, ...n) {
  const e = {
    kind: "schema",
    type: "nullish",
    reference: Cr,
    expects: `(${r.expects} | null | undefined)`,
    async: !1,
    wrapped: r,
    _run(i, u) {
      return (i.value === null || i.value === void 0) && ("default" in this && (i.value = d(
        this,
        i,
        u
      )), i.value === null || i.value === void 0) ? (i.typed = !0, i) : this.wrapped._run(i, u);
    }
  };
  return 0 in n && (e.default = n[0]), e;
}
function Vr(r, ...n) {
  const e = {
    kind: "schema",
    type: "nullish",
    reference: Vr,
    expects: `(${r.expects} | null | undefined)`,
    async: !0,
    wrapped: r,
    async _run(i, u) {
      return (i.value === null || i.value === void 0) && ("default" in this && (i.value = await d(
        this,
        i,
        u
      )), i.value === null || i.value === void 0) ? (i.typed = !0, i) : this.wrapped._run(i, u);
    }
  };
  return 0 in n && (e.default = n[0]), e;
}
function Fr(r) {
  return {
    kind: "schema",
    type: "number",
    reference: Fr,
    expects: "number",
    async: !1,
    message: r,
    _run(n, e) {
      return typeof n.value == "number" && !isNaN(n.value) ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function Lr(r, n) {
  return {
    kind: "schema",
    type: "object",
    reference: Lr,
    expects: "Object",
    async: !1,
    entries: r,
    message: n,
    _run(e, i) {
      var s;
      const u = e.value;
      if (u && typeof u == "object") {
        e.typed = !0, e.value = {};
        for (const l in this.entries) {
          const f = u[l], t = this.entries[l]._run(
            { typed: !1, value: f },
            i
          );
          if (t.issues) {
            const p = {
              type: "object",
              origin: "value",
              input: u,
              key: l,
              value: f
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), (t.value !== void 0 || l in u) && (e.value[l] = t.value);
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function Br(r, n) {
  return {
    kind: "schema",
    type: "object",
    reference: Br,
    expects: "Object",
    async: !0,
    entries: r,
    message: n,
    async _run(e, i) {
      var s;
      const u = e.value;
      if (u && typeof u == "object") {
        e.typed = !0, e.value = {};
        const l = await Promise.all(
          Object.entries(this.entries).map(async ([f, t]) => {
            const p = u[f];
            return [
              f,
              p,
              await t._run({ typed: !1, value: p }, i)
            ];
          })
        );
        for (const [f, t, p] of l) {
          if (p.issues) {
            const c = {
              type: "object",
              origin: "value",
              input: u,
              key: f,
              value: t
            };
            for (const y of p.issues)
              y.path ? y.path.unshift(c) : y.path = [c], (s = e.issues) == null || s.push(y);
            if (e.issues || (e.issues = p.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          p.typed || (e.typed = !1), (p.value !== void 0 || f in u) && (e.value[f] = p.value);
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function Ur(r, n, e) {
  return {
    kind: "schema",
    type: "object_with_rest",
    reference: Ur,
    expects: "Object",
    async: !1,
    entries: r,
    rest: n,
    message: e,
    _run(i, u) {
      var l, f;
      const s = i.value;
      if (s && typeof s == "object") {
        i.typed = !0, i.value = {};
        for (const t in this.entries) {
          const p = s[t], c = this.entries[t]._run(
            { typed: !1, value: p },
            u
          );
          if (c.issues) {
            const y = {
              type: "object",
              origin: "value",
              input: s,
              key: t,
              value: p
            };
            for (const a of c.issues)
              a.path ? a.path.unshift(y) : a.path = [y], (l = i.issues) == null || l.push(a);
            if (i.issues || (i.issues = c.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          c.typed || (i.typed = !1), (c.value !== void 0 || t in s) && (i.value[t] = c.value);
        }
        if (!i.issues || !u.abortEarly) {
          for (const t in s)
            if ($(s, t) && !(t in this.entries)) {
              const p = s[t], c = this.rest._run(
                { typed: !1, value: p },
                u
              );
              if (c.issues) {
                const y = {
                  type: "object",
                  origin: "value",
                  input: s,
                  key: t,
                  value: p
                };
                for (const a of c.issues)
                  a.path ? a.path.unshift(y) : a.path = [y], (f = i.issues) == null || f.push(a);
                if (i.issues || (i.issues = c.issues), u.abortEarly) {
                  i.typed = !1;
                  break;
                }
              }
              c.typed || (i.typed = !1), i.value[t] = c.value;
            }
        }
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function Wr(r, n, e) {
  return {
    kind: "schema",
    type: "object_with_rest",
    reference: Wr,
    expects: "Object",
    async: !0,
    entries: r,
    rest: n,
    message: e,
    async _run(i, u) {
      var l, f;
      const s = i.value;
      if (s && typeof s == "object") {
        i.typed = !0, i.value = {};
        const [t, p] = await Promise.all([
          // Parse schema of each normal entry
          // Hint: We do not distinguish between missing and `undefined` entries.
          // The reason for this decision is that it reduces the bundle size, and
          // we also expect that most users will expect this behavior.
          Promise.all(
            Object.entries(this.entries).map(async ([c, y]) => {
              const a = s[c];
              return [
                c,
                a,
                await y._run({ typed: !1, value: a }, u)
              ];
            })
          ),
          // Parse other entries with rest schema
          // Hint: We exclude specific keys for security reasons
          Promise.all(
            Object.entries(s).filter(
              ([c]) => $(s, c) && !(c in this.entries)
            ).map(
              async ([c, y]) => [
                c,
                y,
                await this.rest._run({ typed: !1, value: y }, u)
              ]
            )
          )
        ]);
        for (const [c, y, a] of t) {
          if (a.issues) {
            const h = {
              type: "object",
              origin: "value",
              input: s,
              key: c,
              value: y
            };
            for (const v of a.issues)
              v.path ? v.path.unshift(h) : v.path = [h], (l = i.issues) == null || l.push(v);
            if (i.issues || (i.issues = a.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          a.typed || (i.typed = !1), (a.value !== void 0 || c in s) && (i.value[c] = a.value);
        }
        if (!i.issues || !u.abortEarly)
          for (const [c, y, a] of p) {
            if (a.issues) {
              const h = {
                type: "object",
                origin: "value",
                input: s,
                key: c,
                value: y
              };
              for (const v of a.issues)
                v.path ? v.path.unshift(h) : v.path = [h], (f = i.issues) == null || f.push(v);
              if (i.issues || (i.issues = a.issues), u.abortEarly) {
                i.typed = !1;
                break;
              }
            }
            a.typed || (i.typed = !1), i.value[c] = a.value;
          }
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function X(r, ...n) {
  const e = {
    kind: "schema",
    type: "optional",
    reference: X,
    expects: `(${r.expects} | undefined)`,
    async: !1,
    wrapped: r,
    _run(i, u) {
      return i.value === void 0 && ("default" in this && (i.value = d(
        this,
        i,
        u
      )), i.value === void 0) ? (i.typed = !0, i) : this.wrapped._run(i, u);
    }
  };
  return 0 in n && (e.default = n[0]), e;
}
function C(r, ...n) {
  const e = {
    kind: "schema",
    type: "optional",
    reference: C,
    expects: `(${r.expects} | undefined)`,
    async: !0,
    wrapped: r,
    async _run(i, u) {
      return i.value === void 0 && ("default" in this && (i.value = await d(
        this,
        i,
        u
      )), i.value === void 0) ? (i.typed = !0, i) : this.wrapped._run(i, u);
    }
  };
  return 0 in n && (e.default = n[0]), e;
}
function V(r, n) {
  return {
    kind: "schema",
    type: "picklist",
    reference: V,
    expects: A(r.map(_), "|"),
    async: !1,
    options: r,
    message: n,
    _run(e, i) {
      return this.options.includes(e.value) ? e.typed = !0 : o(this, "type", e, i), e;
    }
  };
}
function Jr(r) {
  return {
    kind: "schema",
    type: "promise",
    reference: Jr,
    expects: "Promise",
    async: !1,
    message: r,
    _run(n, e) {
      return n.value instanceof Promise ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function Kr(r, n, e) {
  return {
    kind: "schema",
    type: "record",
    reference: Kr,
    expects: "Object",
    async: !1,
    key: r,
    value: n,
    message: e,
    _run(i, u) {
      var l, f;
      const s = i.value;
      if (s && typeof s == "object") {
        i.typed = !0, i.value = {};
        for (const t in s)
          if ($(s, t)) {
            const p = s[t], c = this.key._run(
              { typed: !1, value: t },
              u
            );
            if (c.issues) {
              const a = {
                type: "object",
                origin: "key",
                input: s,
                key: t,
                value: p
              };
              for (const h of c.issues)
                h.path = [a], (l = i.issues) == null || l.push(h);
              if (i.issues || (i.issues = c.issues), u.abortEarly) {
                i.typed = !1;
                break;
              }
            }
            const y = this.value._run(
              { typed: !1, value: p },
              u
            );
            if (y.issues) {
              const a = {
                type: "object",
                origin: "value",
                input: s,
                key: t,
                value: p
              };
              for (const h of y.issues)
                h.path ? h.path.unshift(a) : h.path = [a], (f = i.issues) == null || f.push(h);
              if (i.issues || (i.issues = y.issues), u.abortEarly) {
                i.typed = !1;
                break;
              }
            }
            (!c.typed || !y.typed) && (i.typed = !1), c.typed && (i.value[c.value] = y.value);
          }
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function Hr(r, n, e) {
  return {
    kind: "schema",
    type: "record",
    reference: Hr,
    expects: "Object",
    async: !0,
    key: r,
    value: n,
    message: e,
    async _run(i, u) {
      var l, f;
      const s = i.value;
      if (s && typeof s == "object") {
        i.typed = !0, i.value = {};
        const t = await Promise.all(
          Object.entries(s).filter(([p]) => $(s, p)).map(
            ([p, c]) => Promise.all([
              p,
              c,
              this.key._run({ typed: !1, value: p }, u),
              this.value._run({ typed: !1, value: c }, u)
            ])
          )
        );
        for (const [
          p,
          c,
          y,
          a
        ] of t) {
          if (y.issues) {
            const h = {
              type: "object",
              origin: "key",
              input: s,
              key: p,
              value: c
            };
            for (const v of y.issues)
              v.path = [h], (l = i.issues) == null || l.push(v);
            if (i.issues || (i.issues = y.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          if (a.issues) {
            const h = {
              type: "object",
              origin: "value",
              input: s,
              key: p,
              value: c
            };
            for (const v of a.issues)
              v.path ? v.path.unshift(h) : v.path = [h], (f = i.issues) == null || f.push(v);
            if (i.issues || (i.issues = a.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          (!y.typed || !a.typed) && (i.typed = !1), y.typed && (i.value[y.value] = a.value);
        }
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function Zr(r, n) {
  return {
    kind: "schema",
    type: "set",
    reference: Zr,
    expects: "Set",
    async: !1,
    value: r,
    message: n,
    _run(e, i) {
      var s;
      const u = e.value;
      if (u instanceof Set) {
        e.typed = !0, e.value = /* @__PURE__ */ new Set();
        for (const l of u) {
          const f = this.value._run(
            { typed: !1, value: l },
            i
          );
          if (f.issues) {
            const t = {
              type: "set",
              origin: "value",
              input: u,
              key: null,
              value: l
            };
            for (const p of f.issues)
              p.path ? p.path.unshift(t) : p.path = [t], (s = e.issues) == null || s.push(p);
            if (e.issues || (e.issues = f.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          f.typed || (e.typed = !1), e.value.add(f.value);
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function Qr(r, n) {
  return {
    kind: "schema",
    type: "set",
    reference: Qr,
    expects: "Set",
    async: !0,
    value: r,
    message: n,
    async _run(e, i) {
      var s;
      const u = e.value;
      if (u instanceof Set) {
        e.typed = !0, e.value = /* @__PURE__ */ new Set();
        const l = await Promise.all(
          [...u].map(
            async (f) => [
              f,
              await this.value._run(
                { typed: !1, value: f },
                i
              )
            ]
          )
        );
        for (const [f, t] of l) {
          if (t.issues) {
            const p = {
              type: "set",
              origin: "value",
              input: u,
              key: null,
              value: f
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), e.value.add(t.value);
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function Yr(r, n) {
  return {
    kind: "schema",
    type: "strict_object",
    reference: Yr,
    expects: "Object",
    async: !1,
    entries: r,
    message: n,
    _run(e, i) {
      var s;
      const u = e.value;
      if (u && typeof u == "object") {
        e.typed = !0, e.value = {};
        for (const l in this.entries) {
          const f = u[l], t = this.entries[l]._run(
            { typed: !1, value: f },
            i
          );
          if (t.issues) {
            const p = {
              type: "object",
              origin: "value",
              input: u,
              key: l,
              value: f
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), (t.value !== void 0 || l in u) && (e.value[l] = t.value);
        }
        if (!e.issues || !i.abortEarly) {
          for (const l in u)
            if (!(l in this.entries)) {
              const f = u[l];
              o(this, "type", e, i, {
                input: f,
                expected: "never",
                path: [
                  {
                    type: "object",
                    origin: "value",
                    input: u,
                    key: l,
                    value: f
                  }
                ]
              });
              break;
            }
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function ei(r, n) {
  return {
    kind: "schema",
    type: "strict_object",
    reference: ei,
    expects: "Object",
    async: !0,
    entries: r,
    message: n,
    async _run(e, i) {
      var s;
      const u = e.value;
      if (u && typeof u == "object") {
        e.typed = !0, e.value = {};
        const l = await Promise.all(
          Object.entries(this.entries).map(async ([f, t]) => {
            const p = u[f];
            return [
              f,
              p,
              await t._run({ typed: !1, value: p }, i)
            ];
          })
        );
        for (const [f, t, p] of l) {
          if (p.issues) {
            const c = {
              type: "object",
              origin: "value",
              input: u,
              key: f,
              value: t
            };
            for (const y of p.issues)
              y.path ? y.path.unshift(c) : y.path = [c], (s = e.issues) == null || s.push(y);
            if (e.issues || (e.issues = p.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          p.typed || (e.typed = !1), (p.value !== void 0 || f in u) && (e.value[f] = p.value);
        }
        if (!e.issues || !i.abortEarly) {
          for (const f in u)
            if (!(f in this.entries)) {
              const t = u[f];
              o(this, "type", e, i, {
                input: t,
                expected: "never",
                path: [
                  {
                    type: "object",
                    origin: "value",
                    input: u,
                    key: f,
                    value: t
                  }
                ]
              });
              break;
            }
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function ni(r, n) {
  return {
    kind: "schema",
    type: "strict_tuple",
    reference: ni,
    expects: "Array",
    async: !1,
    items: r,
    message: n,
    _run(e, i) {
      var s;
      const u = e.value;
      if (Array.isArray(u)) {
        e.typed = !0, e.value = [];
        for (let l = 0; l < this.items.length; l++) {
          const f = u[l], t = this.items[l]._run(
            { typed: !1, value: f },
            i
          );
          if (t.issues) {
            const p = {
              type: "array",
              origin: "value",
              input: u,
              key: l,
              value: f
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), e.value.push(t.value);
        }
        if (!(e.issues && i.abortEarly) && this.items.length < u.length) {
          const l = u[r.length];
          o(this, "type", e, i, {
            input: l,
            expected: "never",
            path: [
              {
                type: "array",
                origin: "value",
                input: u,
                key: this.items.length,
                value: l
              }
            ]
          });
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function ri(r, n) {
  return {
    kind: "schema",
    type: "strict_tuple",
    reference: ri,
    expects: "Array",
    async: !0,
    items: r,
    message: n,
    async _run(e, i) {
      var s;
      const u = e.value;
      if (Array.isArray(u)) {
        e.typed = !0, e.value = [];
        const l = await Promise.all(
          this.items.map(async (f, t) => {
            const p = u[t];
            return [
              t,
              p,
              await f._run({ typed: !1, value: p }, i)
            ];
          })
        );
        for (const [f, t, p] of l) {
          if (p.issues) {
            const c = {
              type: "array",
              origin: "value",
              input: u,
              key: f,
              value: t
            };
            for (const y of p.issues)
              y.path ? y.path.unshift(c) : y.path = [c], (s = e.issues) == null || s.push(y);
            if (e.issues || (e.issues = p.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          p.typed || (e.typed = !1), e.value.push(p.value);
        }
        if (!(e.issues && i.abortEarly) && this.items.length < u.length) {
          const f = u[r.length];
          o(this, "type", e, i, {
            input: f,
            expected: "never",
            path: [
              {
                type: "array",
                origin: "value",
                input: u,
                key: this.items.length,
                value: f
              }
            ]
          });
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function ii(r) {
  return {
    kind: "schema",
    type: "string",
    reference: ii,
    expects: "string",
    async: !1,
    message: r,
    _run(n, e) {
      return typeof n.value == "string" ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function ui(r) {
  return {
    kind: "schema",
    type: "symbol",
    reference: ui,
    expects: "symbol",
    async: !1,
    message: r,
    _run(n, e) {
      return typeof n.value == "symbol" ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function si(r, n) {
  return {
    kind: "schema",
    type: "tuple",
    reference: si,
    expects: "Array",
    async: !1,
    items: r,
    message: n,
    _run(e, i) {
      var s;
      const u = e.value;
      if (Array.isArray(u)) {
        e.typed = !0, e.value = [];
        for (let l = 0; l < this.items.length; l++) {
          const f = u[l], t = this.items[l]._run(
            { typed: !1, value: f },
            i
          );
          if (t.issues) {
            const p = {
              type: "array",
              origin: "value",
              input: u,
              key: l,
              value: f
            };
            for (const c of t.issues)
              c.path ? c.path.unshift(p) : c.path = [p], (s = e.issues) == null || s.push(c);
            if (e.issues || (e.issues = t.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          t.typed || (e.typed = !1), e.value.push(t.value);
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function ti(r, n) {
  return {
    kind: "schema",
    type: "tuple",
    reference: ti,
    expects: "Array",
    async: !0,
    items: r,
    message: n,
    async _run(e, i) {
      var s;
      const u = e.value;
      if (Array.isArray(u)) {
        e.typed = !0, e.value = [];
        const l = await Promise.all(
          this.items.map(async (f, t) => {
            const p = u[t];
            return [
              t,
              p,
              await f._run({ typed: !1, value: p }, i)
            ];
          })
        );
        for (const [f, t, p] of l) {
          if (p.issues) {
            const c = {
              type: "array",
              origin: "value",
              input: u,
              key: f,
              value: t
            };
            for (const y of p.issues)
              y.path ? y.path.unshift(c) : y.path = [c], (s = e.issues) == null || s.push(y);
            if (e.issues || (e.issues = p.issues), i.abortEarly) {
              e.typed = !1;
              break;
            }
          }
          p.typed || (e.typed = !1), e.value.push(p.value);
        }
      } else
        o(this, "type", e, i);
      return e;
    }
  };
}
function li(r, n, e) {
  return {
    kind: "schema",
    type: "tuple_with_rest",
    reference: li,
    expects: "Array",
    async: !1,
    items: r,
    rest: n,
    message: e,
    _run(i, u) {
      var l, f;
      const s = i.value;
      if (Array.isArray(s)) {
        i.typed = !0, i.value = [];
        for (let t = 0; t < this.items.length; t++) {
          const p = s[t], c = this.items[t]._run(
            { typed: !1, value: p },
            u
          );
          if (c.issues) {
            const y = {
              type: "array",
              origin: "value",
              input: s,
              key: t,
              value: p
            };
            for (const a of c.issues)
              a.path ? a.path.unshift(y) : a.path = [y], (l = i.issues) == null || l.push(a);
            if (i.issues || (i.issues = c.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          c.typed || (i.typed = !1), i.value.push(c.value);
        }
        if (!i.issues || !u.abortEarly)
          for (let t = this.items.length; t < s.length; t++) {
            const p = s[t], c = this.rest._run({ typed: !1, value: p }, u);
            if (c.issues) {
              const y = {
                type: "array",
                origin: "value",
                input: s,
                key: t,
                value: p
              };
              for (const a of c.issues)
                a.path ? a.path.unshift(y) : a.path = [y], (f = i.issues) == null || f.push(a);
              if (i.issues || (i.issues = c.issues), u.abortEarly) {
                i.typed = !1;
                break;
              }
            }
            c.typed || (i.typed = !1), i.value.push(c.value);
          }
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function fi(r, n, e) {
  return {
    kind: "schema",
    type: "tuple_with_rest",
    reference: fi,
    expects: "Array",
    async: !0,
    items: r,
    rest: n,
    message: e,
    async _run(i, u) {
      var l, f;
      const s = i.value;
      if (Array.isArray(s)) {
        i.typed = !0, i.value = [];
        const [t, p] = await Promise.all([
          // Parse schema of each normal item
          Promise.all(
            this.items.map(async (c, y) => {
              const a = s[y];
              return [
                y,
                a,
                await c._run({ typed: !1, value: a }, u)
              ];
            })
          ),
          // Parse other items with rest schema
          Promise.all(
            s.slice(this.items.length).map(async (c, y) => [
              y + this.items.length,
              c,
              await this.rest._run({ typed: !1, value: c }, u)
            ])
          )
        ]);
        for (const [c, y, a] of t) {
          if (a.issues) {
            const h = {
              type: "array",
              origin: "value",
              input: s,
              key: c,
              value: y
            };
            for (const v of a.issues)
              v.path ? v.path.unshift(h) : v.path = [h], (l = i.issues) == null || l.push(v);
            if (i.issues || (i.issues = a.issues), u.abortEarly) {
              i.typed = !1;
              break;
            }
          }
          a.typed || (i.typed = !1), i.value.push(a.value);
        }
        if (!i.issues || !u.abortEarly)
          for (const [c, y, a] of p) {
            if (a.issues) {
              const h = {
                type: "array",
                origin: "value",
                input: s,
                key: c,
                value: y
              };
              for (const v of a.issues)
                v.path ? v.path.unshift(h) : v.path = [h], (f = i.issues) == null || f.push(v);
              if (i.issues || (i.issues = a.issues), u.abortEarly) {
                i.typed = !1;
                break;
              }
            }
            a.typed || (i.typed = !1), i.value.push(a.value);
          }
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function ci(r) {
  return {
    kind: "schema",
    type: "undefined",
    reference: ci,
    expects: "undefined",
    async: !1,
    message: r,
    _run(n, e) {
      return n.value === void 0 ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function pi(r, ...n) {
  const e = {
    kind: "schema",
    type: "undefinedable",
    reference: pi,
    expects: `(${r.expects} | undefined)`,
    async: !1,
    wrapped: r,
    _run(i, u) {
      return i.value === void 0 && ("default" in this && (i.value = d(
        this,
        i,
        u
      )), i.value === void 0) ? (i.typed = !0, i) : this.wrapped._run(i, u);
    }
  };
  return 0 in n && (e.default = n[0]), e;
}
function oi(r, ...n) {
  const e = {
    kind: "schema",
    type: "undefinedable",
    reference: oi,
    expects: `(${r.expects} | undefined)`,
    async: !0,
    wrapped: r,
    async _run(i, u) {
      return i.value === void 0 && ("default" in this && (i.value = await d(
        this,
        i,
        u
      )), i.value === void 0) ? (i.typed = !0, i) : this.wrapped._run(i, u);
    }
  };
  return 0 in n && (e.default = n[0]), e;
}
function I(r) {
  let n;
  if (r)
    for (const e of r)
      n ? n.push(...e.issues) : n = e.issues;
  return n;
}
function yi(r, n) {
  return {
    kind: "schema",
    type: "union",
    reference: yi,
    expects: A(
      r.map((e) => e.expects),
      "|"
    ),
    async: !1,
    options: r,
    message: n,
    _run(e, i) {
      let u, s, l;
      for (const f of this.options) {
        const t = f._run(
          { typed: !1, value: e.value },
          i
        );
        if (t.typed)
          if (t.issues)
            s ? s.push(t) : s = [t];
          else {
            u = t;
            break;
          }
        else
          l ? l.push(t) : l = [t];
      }
      if (u)
        return u;
      if (s) {
        if (s.length === 1)
          return s[0];
        o(this, "type", e, i, {
          issues: I(s)
        }), e.typed = !0;
      } else {
        if ((l == null ? void 0 : l.length) === 1)
          return l[0];
        o(this, "type", e, i, {
          issues: I(l)
        });
      }
      return e;
    }
  };
}
function ai(r, n) {
  return {
    kind: "schema",
    type: "union",
    reference: ai,
    expects: A(
      r.map((e) => e.expects),
      "|"
    ),
    async: !0,
    options: r,
    message: n,
    async _run(e, i) {
      let u, s, l;
      for (const f of this.options) {
        const t = await f._run(
          { typed: !1, value: e.value },
          i
        );
        if (t.typed)
          if (t.issues)
            s ? s.push(t) : s = [t];
          else {
            u = t;
            break;
          }
        else
          l ? l.push(t) : l = [t];
      }
      if (u)
        return u;
      if (s) {
        if (s.length === 1)
          return s[0];
        o(this, "type", e, i, {
          issues: I(s)
        }), e.typed = !0;
      } else {
        if ((l == null ? void 0 : l.length) === 1)
          return l[0];
        o(this, "type", e, i, {
          issues: I(l)
        });
      }
      return e;
    }
  };
}
function hi() {
  return {
    kind: "schema",
    type: "unknown",
    reference: hi,
    expects: "unknown",
    async: !1,
    _run(r) {
      return r.typed = !0, r;
    }
  };
}
function vi(r, n, e) {
  return {
    kind: "schema",
    type: "variant",
    reference: vi,
    expects: "Object",
    async: !1,
    key: r,
    options: n,
    message: e,
    _run(i, u) {
      const s = i.value;
      if (s && typeof s == "object") {
        let l, f = 0, t = this.key, p = [];
        const c = (y, a) => {
          for (const h of y.options) {
            if (h.type === "variant")
              c(h, new Set(a).add(h.key));
            else {
              let v = !0, x = 0;
              for (const m of a) {
                if (h.entries[m]._run(
                  // @ts-expect-error
                  { typed: !1, value: s[m] },
                  u
                ).issues) {
                  v = !1, t !== m && (f < x || f === x && m in s && !(t in s)) && (f = x, t = m, p = []), t === m && p.push(
                    h.entries[m].expects
                  );
                  break;
                }
                x++;
              }
              if (v) {
                const m = h._run(
                  { typed: !1, value: s },
                  u
                );
                (!l || !l.typed && m.typed) && (l = m);
              }
            }
            if (l && !l.issues)
              break;
          }
        };
        if (c(this, /* @__PURE__ */ new Set([this.key])), l)
          return l;
        o(this, "type", i, u, {
          // @ts-expect-error
          input: s[t],
          expected: A(p, "|"),
          path: [
            {
              type: "object",
              origin: "value",
              input: s,
              key: t,
              // @ts-expect-error
              value: s[t]
            }
          ]
        });
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function mi(r, n, e) {
  return {
    kind: "schema",
    type: "variant",
    reference: mi,
    expects: "Object",
    async: !0,
    key: r,
    options: n,
    message: e,
    async _run(i, u) {
      const s = i.value;
      if (s && typeof s == "object") {
        let l, f = 0, t = this.key, p = [];
        const c = async (y, a) => {
          for (const h of y.options) {
            if (h.type === "variant")
              await c(h, new Set(a).add(h.key));
            else {
              let v = !0, x = 0;
              for (const m of a) {
                if ((await h.entries[m]._run(
                  // @ts-expect-error
                  { typed: !1, value: s[m] },
                  u
                )).issues) {
                  v = !1, t !== m && (f < x || f === x && m in s && !(t in s)) && (f = x, t = m, p = []), t === m && p.push(
                    h.entries[m].expects
                  );
                  break;
                }
                x++;
              }
              if (v) {
                const m = await h._run(
                  { typed: !1, value: s },
                  u
                );
                (!l || !l.typed && m.typed) && (l = m);
              }
            }
            if (l && !l.issues)
              break;
          }
        };
        if (await c(this, /* @__PURE__ */ new Set([this.key])), l)
          return l;
        o(this, "type", i, u, {
          // @ts-expect-error
          input: s[t],
          expected: A(p, "|"),
          path: [
            {
              type: "object",
              origin: "value",
              input: s,
              key: t,
              // @ts-expect-error
              value: s[t]
            }
          ]
        });
      } else
        o(this, "type", i, u);
      return i;
    }
  };
}
function _i(r) {
  return {
    kind: "schema",
    type: "void",
    reference: _i,
    expects: "void",
    async: !1,
    message: r,
    _run(n, e) {
      return n.value === void 0 ? n.typed = !0 : o(this, "type", n, e), n;
    }
  };
}
function Vi(r, n) {
  return V(Object.keys(r.entries), n);
}
function Fi(r, n) {
  const e = {
    ...r.entries
  };
  for (const i of n)
    delete e[i];
  return { ...r, entries: e };
}
function ki(r, n, e) {
  const i = r._run(
    { typed: !1, value: n },
    j(e)
  );
  if (i.issues)
    throw new O(i.issues);
  return i.value;
}
async function bi(r, n, e) {
  const i = await r._run(
    { typed: !1, value: n },
    j(e)
  );
  if (i.issues)
    throw new O(i.issues);
  return i.value;
}
function Li(r, n) {
  const e = (i) => ki(r, i, n);
  return e.schema = r, e.config = n, e;
}
function Bi(r, n) {
  const e = (i) => bi(r, i, n);
  return e.schema = r, e.config = n, e;
}
function Ui(r, n) {
  const e = {};
  for (const i in r.entries)
    e[i] = !n || n.includes(i) ? X(r.entries[i]) : r.entries[i];
  return { ...r, entries: e };
}
function Wi(r, n) {
  const e = {};
  for (const i in r.entries)
    e[i] = !n || n.includes(i) ? C(r.entries[i]) : r.entries[i];
  return { ...r, entries: e };
}
function Ji(r, n) {
  const e = {};
  for (const i of n)
    e[i] = r.entries[i];
  return { ...r, entries: e };
}
function Ki(...r) {
  return {
    ...r[0],
    pipe: r,
    _run(n, e) {
      for (const i of r)
        if (i.kind !== "metadata") {
          if (n.issues && (i.kind === "schema" || i.kind === "transformation")) {
            n.typed = !1;
            break;
          }
          (!n.issues || !e.abortEarly && !e.abortPipeEarly) && (n = i._run(n, e));
        }
      return n;
    }
  };
}
function Hi(...r) {
  return {
    ...r[0],
    pipe: r,
    async: !0,
    async _run(n, e) {
      for (const i of r)
        if (i.kind !== "metadata") {
          if (n.issues && (i.kind === "schema" || i.kind === "transformation")) {
            n.typed = !1;
            break;
          }
          (!n.issues || !e.abortEarly && !e.abortPipeEarly) && (n = await i._run(n, e));
        }
      return n;
    }
  };
}
function Zi(r, n, e) {
  const i = Array.isArray(n) ? n : void 0, u = Array.isArray(n) ? e : n, s = {};
  for (const l in r.entries)
    s[l] = !i || i.includes(l) ? N(r.entries[l], u) : r.entries[l];
  return { ...r, entries: s };
}
function Qi(r, n, e) {
  const i = Array.isArray(n) ? n : void 0, u = Array.isArray(n) ? e : n, s = {};
  for (const l in r.entries)
    s[l] = !i || i.includes(l) ? T(r.entries[l], u) : r.entries[l];
  return { ...r, entries: s };
}
function di(r, n, e) {
  const i = r._run(
    { typed: !1, value: n },
    j(e)
  );
  return {
    typed: i.typed,
    success: !i.issues,
    output: i.value,
    issues: i.issues
  };
}
async function xi(r, n, e) {
  const i = await r._run(
    { typed: !1, value: n },
    j(e)
  );
  return {
    typed: i.typed,
    success: !i.issues,
    output: i.value,
    issues: i.issues
  };
}
function Yi(r, n) {
  const e = (i) => di(r, i, n);
  return e.schema = r, e.config = n, e;
}
function eu(r, n) {
  const e = (i) => xi(r, i, n);
  return e.schema = r, e.config = n, e;
}
function nu(r) {
  return r.wrapped;
}
export {
  U as BASE64_REGEX,
  W as BIC_REGEX,
  J as CUID2_REGEX,
  K as DECIMAL_REGEX,
  H as DIGITS_REGEX,
  Z as EMAIL_REGEX,
  Q as EMOJI_REGEX,
  Y as HEXADECIMAL_REGEX,
  ee as HEX_COLOR_REGEX,
  ne as IMEI_REGEX,
  re as IPV4_REGEX,
  ie as IPV6_REGEX,
  ue as IP_REGEX,
  se as ISO_DATE_REGEX,
  te as ISO_DATE_TIME_REGEX,
  ce as ISO_TIMESTAMP_REGEX,
  le as ISO_TIME_REGEX,
  fe as ISO_TIME_SECOND_REGEX,
  pe as ISO_WEEK_REGEX,
  oe as MAC48_REGEX,
  ye as MAC64_REGEX,
  ae as MAC_REGEX,
  he as NANO_ID_REGEX,
  ve as OCTAL_REGEX,
  me as ULID_REGEX,
  _e as UUID_REGEX,
  O as ValiError,
  o as _addIssue,
  z as _isLuhnAlgo,
  $ as _isValidObjectKey,
  A as _joinExpects,
  _ as _stringify,
  fr as any,
  cr as array,
  pr as arrayAsync,
  B as awaitAsync,
  we as base64,
  Ae as bic,
  or as bigint,
  yr as blob,
  ar as boolean,
  $e as brand,
  De as bytes,
  Ie as check,
  je as checkAsync,
  qe as checkItems,
  Ri as config,
  Se as creditCard,
  Me as cuid2,
  hr as custom,
  vr as customAsync,
  mr as date,
  Re as decimal,
  Ai as deleteGlobalConfig,
  Di as deleteGlobalMessage,
  ji as deleteSchemaMessage,
  Oi as deleteSpecificMessage,
  ze as description,
  Ge as digits,
  Ne as email,
  Te as emoji,
  Xe as empty,
  Ce as endsWith,
  gi as entriesFromList,
  _r as enum,
  _r as enum_,
  Ve as everyItem,
  Fe as excludes,
  zi as fallback,
  Gi as fallbackAsync,
  kr as file,
  Le as filterItems,
  Be as findItem,
  Ue as finite,
  Ni as flatten,
  Ti as forward,
  Xi as forwardAsync,
  br as function,
  br as function_,
  d as getDefault,
  P as getDefaults,
  S as getDefaultsAsync,
  Ee as getDotPath,
  q as getFallback,
  M as getFallbacks,
  R as getFallbacksAsync,
  j as getGlobalConfig,
  ke as getGlobalMessage,
  be as getSchemaMessage,
  de as getSpecificMessage,
  Je as hash,
  He as hexColor,
  Ke as hexadecimal,
  Ze as imei,
  Qe as includes,
  dr as instance,
  Ye as integer,
  xr as intersect,
  Er as intersectAsync,
  en as ip,
  nn as ipv4,
  rn as ipv6,
  Ci as is,
  Pi as isOfKind,
  Si as isOfType,
  Mi as isValiError,
  un as isoDate,
  sn as isoDateTime,
  tn as isoTime,
  ln as isoTimeSecond,
  fn as isoTimestamp,
  cn as isoWeek,
  Vi as keyof,
  wr as lazy,
  Ar as lazyAsync,
  pn as length,
  $r as literal,
  Dr as looseObject,
  Ir as looseObjectAsync,
  jr as looseTuple,
  qr as looseTupleAsync,
  on as mac,
  yn as mac48,
  an as mac64,
  Or as map,
  gr as mapAsync,
  hn as mapItems,
  vn as maxBytes,
  mn as maxLength,
  _n as maxSize,
  kn as maxValue,
  bn as metadata,
  dn as mimeType,
  xn as minBytes,
  En as minLength,
  wn as minSize,
  An as minValue,
  $n as multipleOf,
  Pr as nan,
  Dn as nanoid,
  Sr as never,
  In as nonEmpty,
  Mr as nonNullable,
  Rr as nonNullableAsync,
  zr as nonNullish,
  Gr as nonNullishAsync,
  N as nonOptional,
  T as nonOptionalAsync,
  jn as normalize,
  qn as notBytes,
  On as notLength,
  gn as notSize,
  Pn as notValue,
  Nr as null,
  Nr as null_,
  Tr as nullable,
  Xr as nullableAsync,
  Cr as nullish,
  Vr as nullishAsync,
  Fr as number,
  Lr as object,
  Br as objectAsync,
  Ur as objectWithRest,
  Wr as objectWithRestAsync,
  Sn as octal,
  Fi as omit,
  X as optional,
  C as optionalAsync,
  ki as parse,
  bi as parseAsync,
  Li as parser,
  Bi as parserAsync,
  Ui as partial,
  Wi as partialAsync,
  Mn as partialCheck,
  Rn as partialCheckAsync,
  Ji as pick,
  V as picklist,
  Ki as pipe,
  Hi as pipeAsync,
  Jr as promise,
  zn as rawCheck,
  Gn as rawCheckAsync,
  Nn as rawTransform,
  Tn as rawTransformAsync,
  Xn as readonly,
  Kr as record,
  Hr as recordAsync,
  Cn as reduceItems,
  Vn as regex,
  Zi as required,
  Qi as requiredAsync,
  Fn as safeInteger,
  di as safeParse,
  xi as safeParseAsync,
  Yi as safeParser,
  eu as safeParserAsync,
  Zr as set,
  Qr as setAsync,
  wi as setGlobalConfig,
  $i as setGlobalMessage,
  Ii as setSchemaMessage,
  qi as setSpecificMessage,
  Ln as size,
  Bn as someItem,
  Un as sortItems,
  Wn as startsWith,
  Yr as strictObject,
  ei as strictObjectAsync,
  ni as strictTuple,
  ri as strictTupleAsync,
  ii as string,
  ui as symbol,
  Jn as title,
  Kn as toLowerCase,
  Hn as toMaxValue,
  Zn as toMinValue,
  Qn as toUpperCase,
  Yn as transform,
  er as transformAsync,
  nr as trim,
  rr as trimEnd,
  ir as trimStart,
  si as tuple,
  ti as tupleAsync,
  li as tupleWithRest,
  fi as tupleWithRestAsync,
  ur as ulid,
  ci as undefined,
  ci as undefined_,
  pi as undefinedable,
  oi as undefinedableAsync,
  yi as union,
  ai as unionAsync,
  hi as unknown,
  nu as unwrap,
  sr as url,
  tr as uuid,
  lr as value,
  vi as variant,
  mi as variantAsync,
  _i as void,
  _i as void_
};
